import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList,{MiniList} from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,
        DownloadTemplate,DynamicListArea,BulkEdit,
        LoadGraphic,AddListItem,Step,Dropzone} from '../components/Common';
import {Input,TextButton,Button,InputPhoto,MiniMinusButton} from '../components/Input';
import u from '../utilities/Utilities';
import {Attachment} from '../data/Mimetypes';
import moment from 'moment';

export default class TrainingList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Training Records",
        permission:"training",  //Accepts combined permission module as well
        //combinedField:"",          //Used when permission exists in a combined field
        url:"/training-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/add-training-entry",
        templateURL:"/api/get-add-training-template",
        bulkURL:"/api/add-bulk-training-entries",
        deleteURL:"/api/delete-training-entries",
        spreadsheetURL:"/api/generate-training-spreadsheet",
        overviewURL:"/api/get-all-training-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"training-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        download:{component:DownloadTemplate,props:{skipParams:true}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (permissions.update == 2 && bulkEditOptions.length > 0);
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Add Entry",ref:"add",enabled:(permissions.create==2)},
                {label:"Delete Entries",ref:"delete",enabled:(permissions.delete==2)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
                {label:"Configure Qualifications",ref:"qualification",enabled:(permissions.update),onClick:this.onQualification},
            ]
        })
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    onQualification=()=>{
        window.open("/qualification-list","_blank");
    }

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>

                <div className="page-error">{this.state.error}</div>

                <PageMenu ref={(ref)=>{this.r['pageMenu']=ref}}
                          buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ListItem key={index}
                                          index={index}
                                          content={content}
                                          onChange={onChange}
                                          onContentChange={onContentChange}
                                          registerReference={registerRef}
                                          permissions={this.state.permissions}
                                          settings={this.settings}
                                          />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}

class ListItem extends React.Component{

    state={
        error:"",
        step:"view",
        loading:false,
        loadText:"",
    };

    onDeleteAttachmentRequest=(index)=>{
        this.setState({removeAttachment:index,step:"remove-attachment",error:""});
    }

    onDeleteAttachment=()=>{
        this.setState({loading:true,loadText:"Deleting Attachment..."});
        const content=this.props.content;
        u.post({
            url:"/api/training-remove-attachment",
            data:{
                trainingID:content.trainingID,
                attachment:content.attachments[this.state.removeAttachment]
            },
            success:()=>{
                let content=this.props.content;
                content.attachments.splice(this.state.removeAttachment,1);
                this.props.onChange("attachments",content.attachments,this.props.index);
                this.setState({step:"view",error:"",loading:false});
            },
            error:(error)=>{
                this.setState({loading:false,error:error});
            }
        })
    }

    onDownloadAttachment=(filename,filestamp)=>{
       u.download(filename,filestamp);
    }

    onAddAttachment=async (filename)=>{
        try{
            const {content}=this.props;
            const response = await u.postAsync({
                url:"/api/training-add-attachment",
                data:{
                    trainingID:content.trainingID,
                    userFilname:this.userFilename,
                    filename:filename,
                }
            });
            content.attachments.push(response.data);
            this.props.onChange(content.attachments,"attachments",this.props.index);
            this.setState({loading:false,step:"view"});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    onChange=(value,field,index)=>{
        if(field=="startDateTime" || field == "endDateTime"){
            let {content}=this.props;
            content[field]=value;
            const duration = moment(content.endDateTime).diff(content.startDateTime,"hours",true).toFixed(1);
            this.props.onChange(duration,"duration",this.props.index);
        }
        this.props.onChange(value,field,index);
    }

    render=()=>{
        const {content,settings,permissions} = this.props;
        const canEdit= (permissions.update==2);

        return (
            <div style={{textAlign:"center"}}>

                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>

                <Step active={this.state.step=="view"}>
                    <DynamicListArea listLabel={settings.listLabel}
                                    permission={settings.permission}
                                    content={content}
                                    onChange={this.onChange}
                                    index={this.props.index}
                                    />

                    <div style={{position:"relative",margin:"30px auto 20px auto",textAlign:"center"}}>
                        <div className="list-image-container" style={{textAlign:"center"}}>
                            <h3>Attachments</h3>
                            {
                                (content.attachments.length > 0)
                                ?
                                <div className="list-table-container">
                                    <div className="list-table" style={{maxHeight:"none"}}>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th className="remove"/>
                                                    <th>Attachment</th>
                                                    <th className="attachment-short"/>
                                                    <th className="attachment-short"/>
                                                    <th className="attachment-download"/>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    content.attachments.map(
                                                        (item,index)=>{
                                                            return(
                                                                <tr key={index} className={((item.type=="photo") ? "photo-tr" : "") + " item"}>
                                                                    <td className="remove">
                                                                        <div style={{position:"relative",width:"15px",height:"15px"}}>
                                                                            <MiniMinusButton onClick={()=>{this.onDeleteAttachmentRequest(index)}}
                                                                                            enabled={canEdit}
                                                                                            />
                                                                        </div>
                                                                    </td>
                                                                    <td>{item.filename}</td>
                                                                    <td className="attachment-short">{item.staffName}</td>
                                                                    <td className="attachment-short">{(item.uploadOn=="-") ? "-" : moment(item.uploadOn).format("DD MMM YY hh:mma")}</td>
                                                                    <td className="attachment-download">
                                                                        <img className="misconduct-download"
                                                                                src="/images/input/down-arrow.png"
                                                                                onClick={()=>{this.onDownloadAttachment(item.filename,item.filestamp)}}
                                                                                />
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                :
                                <div className="list-placeholder">
                                    <h3>No Attachments</h3>
                                    <div>Click below to add new attachment</div>
                                </div>
                            }

                            <div style={{margin:"10px auto",textAlign:"center"}}>
                                {
                                    (canEdit)
                                        ?
                                        <TextButton onClick={()=>{this.setState({step:"add-attachment",error:""})}}>Add Attachment</TextButton>
                                        :
                                        null
                                }
                            </div>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="remove-attachment"} scroll={true}>
                    {
                        (content.attachments[this.state.removeAttachment])
                            ?
                            <div style={{fontSize:"14px",textAlign:"center"}}>
                                <h3 className="text-negative">Remove Attachment - {content.attachments[this.state.removeAttachment].filename}</h3>
                                <div className="list-segment-note">Note. This action cannot be undone</div>
                                <div className="segment-buttons">
                                    <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                                    <Button onClick={this.onDeleteAttachment}>Confirm</Button>
                                </div>
                            </div>
                            :
                            null
                    }
                </Step>

                <Step active={this.state.step=="add-attachment"} scroll={true}>
                    <div style={{fontSize:"14px",textAlign:"center"}}>
                        <h3>Add Attachments</h3>
                        <Dropzone label={"Attachment"}
                                  accessibleForPreview={true}
                                  onAdded={(filename)=>{this.userFilename = filename; this.setState({loading:true,loadText:"Uploading..."})}}
                                  onUploaded={this.onAddAttachment}
                                  onError={(error)=>{this.setState({error:error,loading:false})}}
                                  onProgress={(value)=>{this.setState({loadText:"Uploading..." + value + "%"})}}
                                  filetypes={Attachment}
                                  />

                        <div style={{margin:"20px auto"}}>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}

class AddEntry extends React.Component{

    settings={
        addType:0,
        addURL:"/api/add-training-entry",
        templateURL:"/api/get-add-training-template",
        bulkURL:"/api/add-bulk-training-entries",
    };

    r={};

    state={
        step:"add",
        entryData:{
            attachments:[],
            startDateTime:moment().format("YYYY-MM-DD HH:mm:ss"),
            endDateTime:moment().format("YYYY-MM-DD HH:mm:ss"),
            duration:"0.0",
        },
        options:{},
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
        if(!show){
            this.setState({error:""});
        }
    }

    componentDidMount=()=>{
        this.getOptions();

        this.show(this.props.active);
    }

    getOptions=async ()=>{
        try{
            const response=await u.postAsync({
                url:"/api/get-options",
                data:{
                    keys:[
                        "entryType","trainingType","trainingCategory"
                    ]
                }
            });

            this.setState({options:response.data});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onConfirm=(fields)=>{
        const keys = fields.map((item)=>{return item.field});
        let data = {};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }
        const {entryData}=this.state;
        this.settings.overview=this.props.settings.overview;
        this.r[this.props.reference].onValidated({...entryData,...data});
    }

    onComplete=()=>{
        this.setState({
            entryData:{
                attachments:[],
                startDateTime:moment().format("YYYY-MM-DD HH:mm:ss"),
                endDateTime:moment().format("YYYY-MM-DD HH:mm:ss"),
                duration:"0.0",
            },
            step:"add"
        });

        if(this.props.onComplete){
            this.props.onComplete();
        }
    }

    onChange=(value,label,index)=>{
        let {entryData}=this.state;
        entryData[label]=value;
        if(label == "startDateTime" || label == "endDateTime"){
            entryData.duration = moment(entryData.endDateTime).diff(entryData.startDateTime,"hours",true).toFixed(1);
        }
        this.setState({entryData:entryData});
    }

    onAddAttachment=(url)=>{
        let entryData=this.state.entryData;
        entryData.attachments.push({filename:this.userFilename,url:url});
        this.setState({entryData:entryData,step:"add",error:"",loading:false});
    }

    onRemoveAttachment=(index)=>{
       let entryData=this.state.entryData;
       entryData.attachments.splice(index,1);
       this.setState({entryData:entryData});
    }

    onBulkUpload=()=>{
        this.settings.overview=this.props.settings.overview;
        this.r[this.props.reference].onBulkUpload()
    }

    render=()=>{
        const {loading,loadText,step,options,entryData}=this.state;

        const fields=[
            {dataType:"select",label:"Entry Type",field:"entryType",rules:{required:true,defaultValue:this.props.entryType},options:options.entryType,enabled:(this.props.entryType) ? false : true},
            {dataType:"box",label:"NRIC/FIN",field:"searchParam",rules:{required:true,defaultValue:this.props.targetID}, enabled:(this.props.targetID) ? false : true},
            {dataType:"select",label:"Category",field:"category",options:options.trainingCategory},
            {dataType:"box",label:"Provider",field:"trainingProvider",rules:{required:true}},
            {dataType:"select",label:"Type",field:"trainingType",options:options.trainingType},
            {dataType:"box",label:"Training Title",field:"courseTitle",rules:{required:true}},
            {dataType:"date",label:"Start Date",field:"startDate",range:[100,2],rules:{required:true}},
            {dataType:"date",label:"End Date",field:"endDate",range:[100,2],rules:{required:true}},
            {dataType:"box",label:"Duration (Hrs)",field:"duration"},
        ];

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         reference={this.props.reference}
                         settings={this.settings}
                         onComplete={this.onComplete}
                         uploadAsJson={false}
                         inList={this.props.miniList}
                         onToggleForm={this.props.onToggleForm}
                         >

                <div className='segment-content'>
                    <LoadGraphic active={loading} text={loadText}/>
                    <Step active={step=="add"}>
                        <h3>Complete the following fields to create entry</h3>
                        {
                            fields.map(
                                (item,index)=>{
                                    return (
                                        <Input key={index}
                                               ref={(ref)=>{this.r[item.field]=ref}}
                                               values={{
                                                    options:item.options,
                                                    value:entryData[item.field]
                                               }}
                                               fields={{
                                                ...item,
                                                onChange:this.onChange
                                               }}
                                               rules={item.rules}
                                               labelStyle={{width:"40%"}}
                                               inputStyle={{width:"57%"}}
                                               />
                                    )
                                }
                            )
                        }
                        <div className="segment-full-item">
                            <div className="segment-item-label" style={{width:"40%"}}>Attachments:</div>
                            <div className="segment-item-input" style={{width:"57%"}}>
                                <InputPhoto ref="attachments"
                                            label="Attachments"
                                            field="attachments"
                                            type="attachment"
                                            values={{value:entryData.attachments}}
                                            onAdd={()=>{this.setState({step:"add-attachment",error:""})}}
                                            onRemove={this.onRemoveAttachment}
                                            onChange={this.onChange}
                                            rules={{nullText:"Click to add attachment",max:5}}
                                            />
                            </div>
                        </div>

                        {
                            (this.props.targetID)
                                ?
                                null
                                :
                                <div style={{margin:"20px auto",fontSize:"14px"}}>
                                    <TextButton onClick={this.onBulkUpload}>Bulk Upload</TextButton>
                                </div>
                        }

                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={()=>{this.onConfirm(fields)}}>Confirm</Button>
                        </div>
                    </Step>

                    <Step active={step=="add-attachment"}>
                        <Dropzone label={"Attachment"}
                                  accessibleForPreview={true}
                                  onAdded={(filename)=>{this.userFilename = filename; this.setState({loading:true,loadText:"Uploading..."})}}
                                  onUploaded={this.onAddAttachment}
                                  onError={(error)=>{this.setState({error:error,loading:false})}}
                                  onProgress={(value)=>{this.setState({loadText:"Uploading..." + value + "%"})}}
                                  filetypes={Attachment}
                                  />

                        <div className="segment-buttons">
                            <Button onClick={()=>{this.setState({step:"add",error:""})}}>Back</Button>
                        </div>
                    </Step>
                </div>

            </AddListItem>
        )
    }
}

export class MiniTrainingList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Training",
        permission:"training",  //Accepts combined permission module as well
        //combinedField:"",          //Used when permission exists in a combined field
        url:"/training-list",

        addType:0,
        addURL:"/api/add-training-entry",
        templateURL:"/api/get-add-training-template",
        bulkURL:"/api/add-bulk-training-entries",
        deleteURL:"/api/delete-mtraining-entries",
        spreadsheetURL:"/api/generate-training-spreadsheet",
        overviewURL:"/api/get-all-training-entries",

        /**** List Setup ****/
        listLabel:"training-list",
        orderByField:"startDate",
        orderByType:"descending",
    };

    refresh=()=>{
        this.r['list'].refresh();
    }

    render=()=>{
        return(
            <MiniList ref={(ref)=>{this.r["list"]=ref}}
                      settings={this.settings}
                      tags={this.props.tags}
                      pageLength={this.props.pageLength}
                      orderByField={this.props.orderByField}
                      orderByType={this.props.orderByType}
                      addComponent={AddEntry}
                      addProps={this.props.addProps}
                      />
        )
    }
}